<script setup>
import ForgotAsk from './ForgotAsk.vue'
import ForgotConfirm from './ForgotConfirm.vue'
import {reactive} from 'vue'

const emit = defineEmits(['close'])
const page = reactive({
    asked: false,
    auth: {},
})

async function asked(auth) {
    if (auth) {
        page.asked = true
    } else {
        cancel()
    }
}

async function confirmed(ok) {
    emit('close')
}

async function cancel() {
    emit('close')
}
</script>

<template>
    <div>
        <ForgotAsk v-if="!page.asked" v-model="page.auth" @close="asked" />
        <ForgotConfirm v-if="page.asked" v-model="page.auth" @close="confirmed" />
    </div>
</template>
